import { render, staticRenderFns } from "./FDetail.vue?vue&type=template&id=6f8d787f&"
import script from "./FDetail.vue?vue&type=script&lang=js&"
export * from "./FDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports